'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CONSTANTS = undefined;

var _constants = require('./constants');

Object.defineProperty(exports, 'CONSTANTS', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_constants)['default'];
  }
});

var _signatureModal = require('./signature-modal');

var _signatureModal2 = _interopRequireDefault(_signatureModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _signatureModal2['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/ui/signature-modal/index.js
 ** module id = 782
 ** module chunks = 0 1
 **/